import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  FaFileMedicalAlt,
  FaTimes,
  FaPrint,
  FaPlus,
  FaTrash,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import Cookies from "js-cookie";
import SadtLogo from "../../images/sadt.png";
import api from "../../config/configApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// --- Constantes e Interfaces ---
const mmToPx = (mm: number, dpi = 96) => (mm / 25.4) * dpi;
const A4_LANDSCAPE_WIDTH_MM = 297;
const A4_LANDSCAPE_HEIGHT_MM = 210;
const A4_LANDSCAPE_WIDTH_PX = mmToPx(A4_LANDSCAPE_WIDTH_MM);
const A4_LANDSCAPE_HEIGHT_PX = mmToPx(A4_LANDSCAPE_HEIGHT_MM);
const PROCEDIMENTOS_POR_PAGINA = 5;

interface Procedimento {
  tabela: string;
  codProcedimento: string;
  dsProcedimento: string;
  quantidadeProcedimento: string;
}

interface FormData {
  registroAns: string;
  cnpj: string;
  afrafep: string;
  tipoAtendimento: string;
  regime: string;
  cdCarteira: string;
  nome: string;
  cartaoSus: string;
  profissional: string;
  conselho: string;
  nrConselho: string;
  ufConselho: string;
  cbo: string;
  caraterAtendimento: string;
  indicacaoClinica: string;
  procedimentos: Procedimento[];
}

interface GuiaSadtFromAPI {
  id: number;
  nuCpf: string;
  idProfissional: number;
  nmProfissional: string; // Adicionar esta linha
  caraterAtendimento: string;
  tipoAtendimento: number;
  regimeAtendimento: string;
  indicacaoClinica: string;
  dtSolicitacao: string;
  procedimentos: Array<{
    id: number;
    tabelaTuss: number;
    cdProcedimentoTuss: string;
    dsProcedimentoTuss: string;
    qtdSolicitada: number;
  }>;
}

const fieldsConfig = [
  { key: "registroAns", label: "Registro ANS", posx: 17, posy: 20 },
  { key: "cnpj", label: "CNPJ", posx: 17, posy: 54.5 },
  { key: "afrafep", label: "Contratado", posx: 75, posy: 54.5 },
  { key: "cdCarteira", label: "Nº Carteira", posx: 17, posy: 37 },
  { key: "nome", label: "Nome Beneficiário", posx: 110, posy: 37 },
  { key: "cartaoSus", label: "Cartão SUS", posx: 225, posy: 37 },
  { key: "profissional", label: "Profissional", posx: 10, posy: 62 },
  { key: "conselho", label: "Conselho", posx: 110, posy: 62 },
  { key: "nrConselho", label: "Nº Conselho", posx: 145, posy: 62 },
  { key: "ufConselho", label: "UF Conselho", posx: 186, posy: 62 },
  { key: "cbo", label: "CBO", posx: 205, posy: 62 },
  {
    key: "caraterAtendimento",
    label: "Caráter Atendimento",
    posx: 15,
    posy: 72,
  },
  { key: "indicacaoClinica", label: "Indicação Clínica", posx: 95, posy: 72 },
  /*   { key: "tipoAtendimento", label: "Tipo Atendimento", posx: 20, posy: 116 },
  { key: "regime", label: "Regime", posx: 230, posy: 116 }, */
];

const procedimentoLayout = {
  startY: 80.5,
  lineHeight: 3.8,
  columns: {
    tabela: 15,
    codProcedimento: 35,
    dsProcedimento: 69,
    quantidadeProcedimento: 255,
  },
};

interface GuiaSadtProps {
  onClose?: () => void;
}

const GuiaSADT: React.FC<GuiaSadtProps> = ({ onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewPage, setPreviewPage] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingGuides, ] = useState(false);
  const [savedGuides, ] = useState<GuiaSadtFromAPI[]>([]);
  const [showGuideList, setShowGuideList] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const [isEditingExisting, setIsEditingExisting] = useState(false);
  const [profissionais, setProfissionais] = useState<any[]>([]);

  useEffect(() => {
    const fetchProfissionais = async () => {
      try {
        const response = await api.get("/sisclinic/profissionais", {
          headers: {
            Authorization: `Bearer ${Cookies.get("token") || ""}`,
          },
        });
        setProfissionais(response.data);
      } catch (error) {
        console.error("Erro ao buscar profissionais:", error);
      }
    };

    fetchProfissionais();
  }, []);

  // Função para obter nome do profissional
  const getNomeProfissional = (idProfissional: number) => {
    const profissional = profissionais.find(
      (prof) => prof.idProfissional === idProfissional
    );
    return profissional
      ? profissional.nmProfissional
      : "Profissional não encontrado";
  };

  // Adicione esta função para resetar o formulário
  const resetForm = () => {
    setFormData({
      registroAns: "330281",
      cnpj: "09306242000344",
      afrafep:
        "ASSOCIAÇÃO DOS AUDITORES FISCAIS DO ESTADO DA PARAIBA - AFRAFEP",
      conselho: "CRM",
      ufConselho: "PB",
      caraterAtendimento: "ELETIVO",
      tipoAtendimento: "5",
      regime: "01",
      cdCarteira: Cookies.get("NumeroDacarteirinha") || "",
      nome: Cookies.get("Nome") || "",
      profissional: Cookies.get("nmProfissional") || "",
      nrConselho: Cookies.get("CRM") || "",
      cartaoSus: Cookies.get("CartaoSUS") || "",
      cbo: Cookies.get("cboTuss") || "",
      indicacaoClinica: "",
      procedimentos: [
        {
          tabela: "",
          codProcedimento: "",
          dsProcedimento: "",
          quantidadeProcedimento: "1",
        },
      ],
    });
    setIsEditingExisting(false);
  };

// Wrap handleCloseModal in useCallback
const handleCloseModal = useCallback(() => {
  setIsModalOpen(false);
  setShowPreview(false);
  setShowGuideList(false);
  setPreviewPage(0);
  resetForm(); // Resetar o formulário ao fechar
  onClose?.();
}, [onClose]); // Add dependencies

  // Adicione também uma função para voltar ao formulário sem fechar o modal completo
  const handleBackToFormFromPreview = () => {
    setShowPreview(false);
    setPreviewPage(0);
    resetForm(); // Resetar o formulário ao fechar
    // Não resetamos o formulário aqui para manter os dados
  };

  // 2. Corrija a função handleSaveAndPreview para handleSaveAndPrint
  const handleSaveAndPrint = async () => {
    setIsSubmitting(true);
    try {
      // Obter a data atual no formato YYYY-MM-DD
      const hoje = new Date();
      const dtSolicitacao = hoje.toISOString().split("T")[0];

      const payload = {
        nuCpf: Cookies.get("NuCPF") || "",
        idProfissional: Number(Cookies.get("idProfissional") || 0),
        caraterAtendimento: formData.caraterAtendimento,
        tipoAtendimento: 5,
        regimeAtendimento: 1,
        indicacaoClinica: formData.indicacaoClinica, // Adicione esta linha
        dtSolicitacao: dtSolicitacao, // Adicione esta linha
        procedimentos: formData.procedimentos.map((p) => ({
          tabelaTuss: Number(p.tabela) || 0,
          cdProcedimentoTuss: p.codProcedimento || "000000", // Use o código do procedimento se disponível
          dsProcedimentoTuss: p.dsProcedimento,
          qtdSolicitada: Number(p.quantidadeProcedimento),
        })),
      };

      const response = await api.post("/sisclinic/guias-sadt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("token") || ""}`,
        },
      });

      if (response.status >= 200 && response.status < 300) {
        toast.success(`Guia salva com sucesso!`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        // Em vez de mostrar o preview, abra diretamente a impressão
        openPreviewInNewTab();
        setShowPreview(false); // Não mostrar preview
      } else {
        throw new Error(`Erro ao salvar a guia: Status ${response.status}`);
      }
    } catch (error) {
      console.error(error);
            const axiosError = error as any;  // <--- Adicione esta linha

      toast.error(
        `Falha ao salvar a guia: ${
          axiosError?.response?.data?.message
        }`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // 3. Atualize a função loadGuideIntoForm para carregar os novos campos
  const loadGuideIntoForm = (guide: GuiaSadtFromAPI) => {
    setFormData({
      registroAns: "330281",
      cnpj: "09306242000344",
      afrafep:
        "ASSOCIAÇÃO DOS AUDITORES FISCAIS DO ESTADO DA PARAIBA - AFRAFEP",
      conselho: "CRM",
      ufConselho: "PB",
      caraterAtendimento: guide.caraterAtendimento || "ELETIVO",
      tipoAtendimento: guide.tipoAtendimento.toString(),
      regime: guide.regimeAtendimento || "01",
      cdCarteira: Cookies.get("NumeroDacarteirinha") || "",
      nome: Cookies.get("Nome") || "",
      profissional: Cookies.get("nmProfissional") || "",
      nrConselho: Cookies.get("CRM") || "",
      cartaoSus: Cookies.get("CartaoSUS") || "",
      cbo: Cookies.get("cboTuss") || "",
      indicacaoClinica: guide.indicacaoClinica || "", // Carregue a indicação clínica
      procedimentos: guide.procedimentos.map((proc) => ({
        tabela: proc.tabelaTuss.toString(),
        codProcedimento: proc.cdProcedimentoTuss,
        dsProcedimento: proc.dsProcedimentoTuss,
        quantidadeProcedimento: proc.qtdSolicitada.toString(),
      })),
    });

    setShowGuideList(false);
    setIsEditingExisting(true);
    toast.success("Guia carregada com sucesso!", {
      position: "top-right",
      autoClose: 3000,
    });
  };

  const [formData, setFormData] = useState<FormData>({
    registroAns: "330281",
    cnpj: "09306242000344",
    afrafep: "ASSOCIAÇÃO DOS AUDITORES FISCAIS DO ESTADO DA PARAIBA - AFRAFEP",
    conselho: "CRM",
    ufConselho: "PB",
    caraterAtendimento: "ELETIVO",
    tipoAtendimento: "5",
    regime: "01",
    cdCarteira: Cookies.get("NumeroDacarteirinha") || "",
    nome: Cookies.get("Nome") || "",
    profissional: Cookies.get("nmProfissional") || "",
    nrConselho: Cookies.get("CRM") || "",
    cartaoSus: Cookies.get("CartaoSUS") || "",
    cbo: Cookies.get("cboTuss") || "",
    indicacaoClinica: "",
    procedimentos: [
      {
        tabela: "",
        codProcedimento: "",
        dsProcedimento: "",
        quantidadeProcedimento: "1",
      },
    ],
  });

  const handleOpenModal = () => setIsModalOpen(true);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProcedimentoChange = (
    index: number,
    field: keyof Procedimento,
    value: string
  ) => {
    const newProcedimentos = [...formData.procedimentos];
    newProcedimentos[index][field] = value;
    setFormData((prev) => ({ ...prev, procedimentos: newProcedimentos }));
  };

  const handleAddProcedimento = () => {
    setFormData((prev) => ({
      ...prev,
      procedimentos: [
        ...prev.procedimentos,
        {
          tabela: "",
          codProcedimento: "",
          dsProcedimento: "",
          quantidadeProcedimento: "1",
        },
      ],
    }));
  };

  const handleRemoveProcedimento = (index: number) => {
    const newProcedimentos = formData.procedimentos.filter(
      (_, i) => i !== index
    );
    setFormData((prev) => ({ ...prev, procedimentos: newProcedimentos }));
  };

  const openPreviewInNewTab = () => {
    const mainFieldsHtml = fieldsConfig
      .map((field) => {
        const value =
          formData[field.key as keyof Omit<FormData, "procedimentos">] || "";
        return `<div class="field" style="left: ${field.posx}mm; top: ${field.posy}mm;">${value}</div>`;
      })
      .join("");

    const procedureChunks = [];
    for (
      let i = 0;
      i < formData.procedimentos.length;
      i += PROCEDIMENTOS_POR_PAGINA
    ) {
      procedureChunks.push(
        formData.procedimentos.slice(i, i + PROCEDIMENTOS_POR_PAGINA)
      );
    }

    const pagesHtml = procedureChunks
      .map((chunk) => {
        const procedimentosHtml = chunk
          .map((proc, index) => {
            const currentY =
              procedimentoLayout.startY + index * procedimentoLayout.lineHeight;
            return `
              <div class="field" style="left: ${procedimentoLayout.columns.tabela}mm; top: ${currentY}mm;">${proc.tabela}</div>
              <div class="field" style="left: ${procedimentoLayout.columns.codProcedimento}mm; top: ${currentY}mm;">${proc.codProcedimento}</div>
              <div class="field" style="left: ${procedimentoLayout.columns.dsProcedimento}mm; top: ${currentY}mm;">${proc.dsProcedimento}</div>
              <div class="field" style="left: ${procedimentoLayout.columns.quantidadeProcedimento}mm; top: ${currentY}mm;">${proc.quantidadeProcedimento}</div>
            `;
          })
          .join("");
        return `<div class="page-container">${mainFieldsHtml}${procedimentosHtml}</div>`;
      })
      .join("");

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <title>Impressão de Guia SADT - ${formData.nome}</title>
        <style>
          body { margin: 0; padding: 0; font-family: Arial, sans-serif; font-size: 8pt; color: black; }
          .page-container {
            position: relative;
            width: ${A4_LANDSCAPE_WIDTH_MM}mm;
            height: ${A4_LANDSCAPE_HEIGHT_MM}mm;
            background-image: url('${SadtLogo}');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            page-break-after: always;
          }
          .page-container:last-child {
            page-break-after: auto;
          }
          .field { position: absolute; white-space: nowrap; font-weight: bold; }
          @media print { @page { size: A4 landscape; margin: 0; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        </style>
      </head>
      <body>${pagesHtml}</body>
      </html>`;

    const newWindow = window.open("", `${formData.nome}_blank`);
    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(htmlContent);
      newWindow.document.close();

      // Forçar a abertura da caixa de diálogo de impressão após um pequeno delay
      setTimeout(() => {
        newWindow.focus();
        newWindow.print();
        // Não fechar a janela imediatamente para dar tempo de imprimir
      }, 500);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isModalOpen) handleCloseModal();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, handleCloseModal]);

  const renderGuideList = () => {
    if (isLoadingGuides) {
      return (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>
      );
    }

    // Na função renderGuideList, modifique a verificação de guias vazias
    if (savedGuides.length === 0) {
      return (
        <div className="text-center py-8 text-gray-500">
          {isLoadingGuides ? "" : "Nenhuma guia encontrada para seu CPF."}
        </div>
      );
    }

    return (
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {savedGuides
          .sort(
            (a, b) =>
              new Date(b.dtSolicitacao).getTime() -
              new Date(a.dtSolicitacao).getTime()
          )
          .map((guide) => {
            // Corrigindo a formatação da data para evitar problemas de fuso horário
            const [year, month, day] = guide.dtSolicitacao.split("-");
            const dataFormatada = `${day}/${month}/${year}`;

            return (
              <div
                key={guide.id}
                className="bg-white p-4 rounded-lg shadow border border-gray-200 hover:border-blue-300 cursor-pointer"
                onClick={() => loadGuideIntoForm(guide)}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="font-semibold text-gray-800">
                      Data:{dataFormatada}
                    </h3>
                    <p className="text-sm text-gray-900">
                      Caráter: {guide.caraterAtendimento} | Tipo:{" "}
                      {guide.tipoAtendimento} | Regime:{" "}
                      {guide.regimeAtendimento}
                    </p>
                    <p className="text-sm text-gray-900">
                      <strong>Profissional:</strong>{" "}
                      {getNomeProfissional(guide.idProfissional)}
                    </p>
                    <p className="text-sm text-gray-900">
                      Indicação Clinica: {guide.indicacaoClinica}
                    </p>
                    <p className="text-sm text-gray-900">
                      Procedimentos: {guide.procedimentos.length}
                    </p>
                  </div>
                  <FaChevronRight className="text-gray-900" />
                </div>
              </div>
            );
          })}
      </div>
    );
  };

  const renderForm = () => {
    const editableKeys = ["indicacaoClinica", "tipoAtendimento", "regime"];

    return (
      <div className="space-y-2">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-gray-900 border-b mb-4">
            Dados Gerais
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-2 gap-y-1 items-center">
            {fieldsConfig.map(({ key, label }) => {
              if (editableKeys.includes(key)) {
                if (key === "indicacaoClinica") {
                  return (
                    <div key={key} className="lg:col-span-3 mt-2">
                      <label
                        htmlFor={key}
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        {label}
                      </label>
                      <textarea
                        id={key}
                        name={key}
                        rows={2}
                        value={
                          formData[key as keyof Omit<FormData, "procedimentos">]
                        }
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                      />
                    </div>
                  );
                }
                return (
                  <div key={key}>
                    <label
                      htmlFor={key}
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      {label}
                    </label>
                    <input
                      id={key}
                      name={key}
                      type="text"
                      value={
                        formData[key as keyof Omit<FormData, "procedimentos">]
                      }
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
                );
              }

              return (
                <div key={key}>
                  <p className="text-sm text-gray-800">
                    <span className="font-semibold text-black-600">
                      {label}:
                    </span>{" "}
                    {formData[key as keyof Omit<FormData, "procedimentos">]}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-lg font-semibold text-gray-900 border-b pb-2 mb-4">
            Procedimentos Solicitados
          </h3>
          <div className="space-y-4">
            {formData.procedimentos.map((proc, index) => (
              <div key={index} className="grid grid-cols-12 gap-4 items-end">
                <div className="col-span-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Descrição
                  </label>
                  <input
                    type="text"
                    value={proc.dsProcedimento}
                    onChange={(e) =>
                      handleProcedimentoChange(
                        index,
                        "dsProcedimento",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Quantidade
                  </label>
                  <input
                    type="number"
                    min="1"
                    value={proc.quantidadeProcedimento}
                    onChange={(e) =>
                      handleProcedimentoChange(
                        index,
                        "quantidadeProcedimento",
                        e.target.value
                      )
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="col-span-1">
                  {formData.procedimentos.length > 1 && (
                    <button
                      onClick={() => handleRemoveProcedimento(index)}
                      className="p-2 text-red-500 hover:text-red-700"
                    >
                      <FaTrash size={18} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
          <button
            onClick={handleAddProcedimento}
            className="mt-4 bg-gray-200 hover:bg-gray-300 text-gray-900 font-semibold py-2 px-4 rounded-md flex items-center gap-2"
          >
            <FaPlus /> Adicionar Procedimento
          </button>
        </div>
      </div>
    );
  };

  const renderPreview = () => {
    const procedureChunks = [];
    for (
      let i = 0;
      i < formData.procedimentos.length;
      i += PROCEDIMENTOS_POR_PAGINA
    ) {
      procedureChunks.push(
        formData.procedimentos.slice(i, i + PROCEDIMENTOS_POR_PAGINA)
      );
    }
    const currentPageProcedures = procedureChunks[previewPage] || [];
    const totalPages = procedureChunks.length;

    return (
      <div className="bg-white p-6 rounded-lg shadow-md flex flex-col justify-center items-center">
        <div
          className="relative overflow-hidden border-2 border-dashed"
          style={{
            width: `${A4_LANDSCAPE_WIDTH_PX}px`,
            height: `${A4_LANDSCAPE_HEIGHT_PX}px`,
            backgroundImage: `url(${SadtLogo})`,
            backgroundSize: "100% 100%",
            color: "black",
          }}
        >
          {fieldsConfig.map((field) => (
            <div
              key={field.key}
              className="absolute whitespace-nowrap"
              style={{
                left: `${mmToPx(field.posx)}px`,
                top: `${mmToPx(field.posy)}px`,
                fontSize: "8pt",
                fontWeight: "bold",
              }}
            >
              {formData[field.key as keyof Omit<FormData, "procedimentos">]}
            </div>
          ))}
          {currentPageProcedures.map((proc, index) => {
            const currentY =
              procedimentoLayout.startY + index * procedimentoLayout.lineHeight;
            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    position: "absolute",
                    left: mmToPx(procedimentoLayout.columns.tabela),
                    top: mmToPx(currentY),
                    fontSize: "8pt",
                    fontWeight: "bold",
                  }}
                >
                  {proc.tabela}
                </div>
                <div
                  style={{
                    position: "absolute",
                    left: mmToPx(procedimentoLayout.columns.codProcedimento),
                    top: mmToPx(currentY),
                    fontSize: "8pt",
                    fontWeight: "bold",
                  }}
                >
                  {proc.codProcedimento}
                </div>
                <div
                  style={{
                    position: "absolute",
                    left: mmToPx(procedimentoLayout.columns.dsProcedimento),
                    top: mmToPx(currentY),
                    fontSize: "8pt",
                    fontWeight: "bold",
                  }}
                >
                  {proc.dsProcedimento}
                </div>
                <div
                  style={{
                    position: "absolute",
                    left: mmToPx(
                      procedimentoLayout.columns.quantidadeProcedimento
                    ),
                    top: mmToPx(currentY),
                    fontSize: "8pt",
                    fontWeight: "bold",
                  }}
                >
                  {proc.quantidadeProcedimento}
                </div>
              </React.Fragment>
            );
          })}
        </div>
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-4 mt-4">
            <button
              onClick={() => setPreviewPage(previewPage - 1)}
              disabled={previewPage === 0}
              className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FaChevronLeft />
            </button>
            <span className="font-semibold text-gray-700">
              Página {previewPage + 1} de {totalPages}
            </span>
            <button
              onClick={() => setPreviewPage(previewPage + 1)}
              disabled={previewPage === totalPages - 1}
              className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <FaChevronRight />
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded flex items-center gap-2"
      >
        <FaFileMedicalAlt /> Guia SADT
      </button>
      {isModalOpen && (
        <div
          onClick={handleCloseModal}
          className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
        >
          <div
            className="bg-gray-50 rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] flex flex-col"
            ref={modalRef}
            onClick={(e) => e.stopPropagation()} // Move o stopPropagation para aqui
          >
            <div className="flex justify-between items-center border-b p-4 bg-white rounded-t-xl sticky top-0 z-10">
              <h2 className="text-2xl font-bold text-gray-800">
                {showGuideList
                  ? "Guias Salvas"
                  : showPreview
                  ? "Pré-visualização da Guia SADT"
                  : "Gerar Guia de Solicitação SADT"}
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-400 hover:text-gray-600 focus:outline-none"
                aria-label="Fechar modal"
              >
                <FaTimes size={24} />
              </button>
            </div>

            <div className="p-6 overflow-y-auto">
              {showGuideList
                ? renderGuideList()
                : showPreview
                ? renderPreview()
                : renderForm()}
            </div>

            <div className="border-t p-4 flex justify-between bg-white rounded-b-xl sticky bottom-0 z-10 w-full">
              {/* Botão Cancelar ou Voltar (esquerda) */}
              <div>
                {showPreview ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBackToFormFromPreview();
                    }}
                    className="bg-gray-900 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded-lg transition-colors"
                  >
                    Voltar
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCloseModal();
                    }}
                    className="bg-red-900 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-lg transition-colors"
                  >
                    Cancelar
                  </button>
                )}
              </div>

              {/* Botão Imprimir ou Salvar & Imprimir (direita) */}
              <div className="ml-auto">
                {showGuideList ? null : !showPreview ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isEditingExisting) {
                        openPreviewInNewTab(); // Para guias existentes, apenas imprimir
                      } else {
                        handleSaveAndPrint(); // Para novas guias, salvar e imprimir
                      }
                    }}
                    disabled={isSubmitting}
                    className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50"
                  >
                    {isSubmitting ? (
                      "Salvando..."
                    ) : isEditingExisting ? (
                      <>
                        <FaPrint /> Imprimir
                      </>
                    ) : (
                      <>
                        <FaFileMedicalAlt /> Salvar & Imprimir
                      </>
                    )}
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openPreviewInNewTab();
                    }}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg flex items-center gap-2 transition-colors"
                  >
                    <FaPrint /> Imprimir
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GuiaSADT;
